import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import PremiumIcon from '@wix/da-ds/pkg/Icons/24x24/Premium';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
const PremiumFolderDataIcon = (_param)=>{
    var { premiumFolderData  } = _param, iconProps = _object_without_properties(_param, [
        "premiumFolderData"
    ]);
    switch(premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.type){
        case 'paid':
            return /*#__PURE__*/ React.createElement(PremiumIcon, _extends({}, iconProps));
        case 'watchers':
            return /*#__PURE__*/ React.createElement(FollowingWatchIcon, _extends({}, iconProps));
        default:
            return null;
    }
};
PremiumFolderDataIcon.displayName = 'PremiumFolderDataIcon';
export default PremiumFolderDataIcon;
